const galleriesSelector = ({ adminState: { adminGalleryState } }) => adminGalleryState.galleries
const currentGallerySelector = ({ adminState: { adminGalleryState } }) => adminGalleryState.currentGallery

export {
    galleriesSelector,
    currentGallerySelector,
}